import { createI18n } from 'vue-i18n'
import { useLocalStorage } from '@vueuse/core'

export const DEFAULT_LANGUAGE = 'en'
export const BROWSER_LANGUAGE = navigator?.language?.split('-')[0]
export const userLanguage = useLocalStorage('saiftyUserLanguage', DEFAULT_LANGUAGE)

type LocaleModule = {
  default: Record<string, string>
}

function getMessages() {
  const messages: Record<string, Record<string, string>> = {}

  // See: https://vitejs.dev/guide/features.html#glob-import
  const localeFiles = import.meta.glob('../../locales/*.json', {
    eager: true,
  }) as Record<string, LocaleModule>

  const CGNlocaleFile = import.meta.glob('../config/CGNCustomTranslations.json', {
    eager: true,
  }) as Record<string, LocaleModule>

  const defaultMessagesFromCGNFile = CGNlocaleFile['../config/CGNCustomTranslations.json'].default

  for (const path in localeFiles) {
    // E.g: ../../locales/de.json
    const pathParts = path.split('/')
    const fileName = pathParts[pathParts.length - 1] // ej: "de.json"
    // E.g: de.json -> de
    const locale = fileName.replace('.json', '') // "de"

    const fileMessages = localeFiles[path].default

    if (locale === DEFAULT_LANGUAGE) {
      // For the default language the keys are the same as the value
      const defaultLangMessages: Record<string, string> = {}
      for (const key in fileMessages) {
        if (fileMessages[key]) {
          defaultLangMessages[key] = fileMessages[key]
        } else {
          defaultLangMessages[key] = key
        }
      }

      messages[locale] = {
        ...defaultLangMessages,
        ...defaultMessagesFromCGNFile,
      }
    } else {
      // E.g: "de" => { "Hello": "Hallo" }
      messages[locale] = {
        ...fileMessages,
        ...defaultMessagesFromCGNFile,
      }
    }
  }

  return messages
}

const messages = getMessages()

const i18n = createI18n({
  locale: Object.keys(messages).includes(userLanguage.value) ? userLanguage.value : DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  legacy: false,
  messages,
  silentTranslationWarn: true, // Avoid show missing translation warning in the console log in order to improve the develop experience
})

export default i18n
